class NameChangedEvent {
  bookingNumber: string;
}

export default NameChangedEvent;
